"use client";

import { Button, Col, Flex, Result, Row } from "antd";
import React from "react";
import img from "@/images/500.jpg";
import Logo from "@/components/Logo";
import { LayoutContext } from "@/lib/LayoutContext";

export default class ErrorBoundary extends React.Component {
  static contextType = LayoutContext;

  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    if (
      error?.digest?.startsWith("NEXT_REDIRECT") ||
      error?.digest?.startsWith("NEXT_NOT_FOUND") ||
      error?.message === "NEXT_REDIRECT" ||
      error?.message === "NEXT_NOT_FOUND"
    ) {
      throw error;
    }

    console.error(
      "digest:",
      error?.digest,
      "message:",
      error?.message,
      "derive",
    );

    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    if (
      error?.digest?.startsWith("NEXT_REDIRECT") ||
      error?.digest?.startsWith("NEXT_NOT_FOUND") ||
      error?.message === "NEXT_REDIRECT" ||
      error?.message === "NEXT_NOT_FOUND"
    ) {
      throw error;
    }

    console.error(error);

    console.error("digest:", error?.digest, "message:", error?.message);
  }

  showingFallback() {
    return this.state.hasError || !!this.props.error;
  }

  componentDidMount() {
    if (this.showingFallback()) {
      this.context?.setHideFooter?.(true);
    }
  }

  componentDidUpdate() {
    const showing = this.showingFallback();
    if (showing !== this._lastHideFooter) {
      this._lastHideFooter = showing;
      this.context?.setHideFooter?.(showing);
    }
  }

  componentWillUnmount() {
    this.context?.setHideFooter?.(false);
  }

  render() {
    if (this.showingFallback()) {
      if (this.props.fallback) {
        return this.props.fallback;
      }
      return (
        <div style={{ padding: "2rem", marginBottom: 80, textAlign: "center" }}>
          <Row>
            <Col
              xs={24}
              md={{ span: 20, offset: 2 }}
              lg={{ span: 12, offset: 6 }}
              xl={{ span: 8, offset: 8 }}
            >
              <Flex vertical align="center">
                <Logo width={120} />
                <Result
                  icon={
                    <Flex justify="center" className="w-full">
                      <img
                        src={img.src}
                        alt="500"
                        style={{ height: 300, width: "auto" }}
                      />
                    </Flex>
                  }
                  title={
                    <div className="text-black ff-title font-bold">
                      Uh-oh, something broke backstage 😬
                    </div>
                  }
                  subTitle="Looks like the server missed its cue. We're on it like a spotlight—try refreshing or check back in a bit. The show must go on!"
                  extra={
                    <Button
                      type="primary"
                      onClick={() => (window.location.href = "/")}
                    >
                      Take me back to base
                    </Button>
                  }
                />
              </Flex>
            </Col>
          </Row>

          {/* <h2>Something went wrong.</h2>
          <p>{this.state.error?.message}</p> */}
        </div>
      );
    }

    return this.props.children;
  }
}
